export default __webpack_public_path__ + "static/media/advantage_icon5.6656b133.png";